<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  mounted() {

  },

  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
  @import '@/base/global-styles.scss';
</style>
